export default function Result() {
  return <div>result</div>;
}
